import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_SERVER_URL || '';

const oktaApiClient = axios.create({
  baseURL: API_BASE ? `${API_BASE}/maiApi` : '/maiApi',
  withCredentials: true,
});

export default oktaApiClient;
